export default __webpack_public_path__ + "static/media/logo.eea850f3.png";